import { render, staticRenderFns } from "./Watchlistcard.vue?vue&type=template&id=591763a2&scoped=true&"
import script from "./Watchlistcard.vue?vue&type=script&lang=js&"
export * from "./Watchlistcard.vue?vue&type=script&lang=js&"
import style0 from "./Watchlistcard.vue?vue&type=style&index=0&id=591763a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591763a2",
  null
  
)

export default component.exports